export default "__VITE_ASSET__BXkG$WGM__"